import React, { useMemo } from 'react';
import DrawerBar from '@/common/components/NavigationBar/index';
import { routes } from '@/app/routing/index';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ArticleIcon from '@mui/icons-material/Article';
import InfoIcon from '@mui/icons-material/Info';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import { TASK_MODULES } from '@/common/constants/constants';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';

const guidePdf = '/docs/PAEM After Care User Guide.pdf';

const Navigation = () => {
  const { t } = useTranslation();

  const list = useMemo(() => {
    const copyrightSup = <CopyrightSup />;

    return [
      {
        link: `${routes.dashboard.taskList}/${TASK_MODULES.IMMEDIATE}`,
        text: (
          <>
            <AssignmentTurnedInIcon /> {t('Task list')}
          </>
        ),
        isActive: (match, location) =>
          location.pathname.includes(routes.dashboard.taskList),
      },
      {
        link: `${routes.dashboard.profile}/main`,
        text: (
          <>
            <FolderSharedIcon /> <span>{t("Decedent's profile")}</span>
          </>
        ),
        isActive: (match, location) =>
          location.pathname.includes(routes.dashboard.profile),
      },
      {
        link: routes.dashboard.entryLists,
        text: (
          <>
            <ArticleIcon /> <span>{t('Data entry lists')}</span>
          </>
        ),
      },
      {
        link: routes.dashboard.finInstitutions,
        text: (
          <>
            <AccountBalanceIcon />{' '}
            <Tooltip title={t('Decedent’s Financial Institutions')}>
              <span>{t('Financials')}</span>
            </Tooltip>
          </>
        ),
      },
      {
        link: routes.dashboard.generalNotes,
        text: (
          <>
            <StickyNote2Icon /> <span>{t('General notes')}</span>
          </>
        ),
      },
      {
        link: routes.dashboard.about,
        text: (
          <>
            <InfoIcon />{' '}
            <Tooltip
              title={
                <Trans
                  i18nKey="About PAEM After Care<copyrightSup/>"
                  components={{ copyrightSup }}
                />
              }
            >
              <span>{t('About')}</span>
            </Tooltip>
          </>
        ),
      },
      {
        link: guidePdf,
        external: true,
        target: '_blank',
        rel: 'noopener noreferrer',
        highlightOnHover: true,
        endAdornment: <DownloadIcon fontSize="small" />,
        text: (
          <>
            <HelpCenterIcon /> <span>{t('User guides')}</span>
          </>
        ),
      },
    ];
  }, [t]);
  return <DrawerBar list={list} />;
};

export default Navigation;
